export default __webpack_public_path__ + "static/media/sahil-mentor.0ce879ef.jpg";